import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-pseudo-link' })
export class PseudoLinkComponent {
	private href: string;
	constructor(private element: HTMLElement) {
		this.href = this.element.getAttribute('data-href');
		if (this.href) {
			this.element.addEventListener('click', (e) => {
				e.preventDefault();
				window.location = this.href;
			});
		}
	}
}
